import { ElMessage } from 'element-plus';
import { getStorage } from '@/plugins/store';
import RegisterForm from './components/RegisterForm';
import Captcha from '@/components/Captcha/index.vue';
export default {
  name: 'login',
  components: {
    RegisterForm,
    Captcha
  },

  created() {
    this.getObjectStatus();
    this.getBaseSet();
  },

  data() {
    let RegPhone = /^[1][34578][0-9]{9}$/;
    let RegResetPass = /^(?![0-9]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;

    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error(`请输入您的${this.logInType == 2 ? '工号' : '手机号'}`));
      } else {
        callback();
      }
    };

    const validatePassword = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error('请输入您的密码'));
      } else {
        callback();
      }
    };

    const validPhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的手机号'));
      } else if (!RegPhone.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };

    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!RegResetPass.test(value)) {
        callback(new Error('请输入8-16位密码(大小写字母+数字)'));
      } else {
        if (this.resetForm.copyPassword !== '') {
          this.$refs.resetForm.validateField('copyPassword');
        }

        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      // url: location.href.substring(location.href.indexOf('?') + 1),
      url: location.href,
      service: this.$utils.getUrlParams('service'),
      loginForm: {
        username: '',
        password: '',
        schoolName: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }]
      },
      resetRules: {
        phoneNumber: [{
          required: true,
          trigger: 'blur',
          validator: validPhoneNumber
        }],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入验证码'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位验证码',
          trigger: 'blur'
        }],
        password: [{
          validator: validatePass,
          required: true,
          trigger: 'blur'
        }],
        copyPassword: [{
          validator: validatePass2,
          required: true,
          trigger: 'change'
        }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      userInfo: {},
      showChangeDialog: false,
      captchaValid: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        copyNewword: ''
      },
      showResetDialog: false,
      resetForm: {
        userName: '',
        phoneNumber: '',
        code: '',
        password: '',
        copyPassword: ''
      },
      timer: null,
      count: '',
      codeShow: true,
      randstr: '',
      ticket: '',
      codeSuccess: false,
      showSchoolLogin: true,
      logInType: '1',
      showZhs: false,
      showSso: false,
      logoUrl: '',
      loginBg: '',
      showRegisterForm: false
    };
  },

  computed: {
    noTicketUrl() {
      return this.$utils.removeUrlParam(['ticket']);
    }

  },
  methods: {
    async getLogin() {
      let params = {
        password: this.loginForm.password,
        username: this.loginForm.username,
        logInType: this.logInType
      };
      const res = await this.$http.getLogin(params, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log(res);
      if (res.token) this.$utils.setCookie('X-Access-Token', res.token);
      this.userInfo = res;
      console.log('用户信息', this.userInfo);
    },

    // 点击登录
    handleLogin(e) {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.getLogin().then(res => {
            if (this.service) {
              window.location.href = this.service;
            } else {
              window.location.href = `/index.html`;
            }
          }).catch(error => {
            this.loading = false;
            console.log('1234', error); // ElMessage.error(error.data.message)
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    zhsLogin() {
      const host = window.location.protocol + '//' + window.location.host;
      const loginUrl = host + '/login.html';
      const url = host + '/index.html';
      window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${loginUrl}&source=${this.$schoolId}`; // window.location.href = `https://passport.zhihuishu.com/login?service=http://cdtu.zhihuishu.com`;
    },

    async changePassword() {
      let params = {
        fomrerPassword: this.passwordForm.oldPassword,
        newPassword: this.passwordForm.newPassword,
        username: this.loginForm.username
      };
      const res = await this.$http.changePassword(params);
      console.log(res);
    },

    showReset() {
      this.logInType = 1;
      this.showResetDialog = true;
    },

    // 学号登录
    schoolLogin() {
      this.logInType = 2;
      this.showSchoolLogin = true;
    },

    // 手机号登录
    phoneLogin() {
      this.showSchoolLogin = false;
      this.logInType = 1;
    },

    // 确认重置
    async submitInfo() {
      let params1 = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber
      };
      let params = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber,
        newPassword: this.resetForm.password // username: this.resetForm.phoneNumber

      };
      const res1 = await this.$http.validateCode(params1, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log(res1);

      if (res1 == false) {
        return ElMessage.error('您输入的验证码不正确');
      } else {
        const res = await this.$http.resetPass(params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        console.log(res);
        window.location.href = `${this.$baseUrl}/login.html`;
        ElMessage('请使用新密码登录');
      }
    },

    confirmReset() {
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          this.submitInfo().then(() => {// window.location.href = `${this.$baseUrl}/login.html`
          }).catch(error => {
            ElMessage(error.message);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    getCode() {
      let Reg = /^[1][2345789][0-9]{9}$/;

      if (!this.resetForm.phoneNumber) {
        ElMessage.warning({
          message: '请先输入您的手机号码',
          type: 'warning'
        });
        return;
      } else {
        if (Reg.test(this.resetForm.phoneNumber)) {
          this.$refs.CaptchaEl.show();
        } else {
          ElMessage.warning({
            message: '手机号码格式不正确',
            type: 'warning'
          });
        }
      }
    },

    /* 图形验证成功 */
    captchaSuccess(res) {
      console.log('captchaSuccess :>> ', res);
      this.randstr = res.randstr;
      this.ticket = res.ticket;
      this.sendCode();
    },

    async codeMessage() {
      let params = {
        mobile: this.resetForm.phoneNumber,
        randStr: this.randstr,
        ticket: this.ticket,
        username: this.resetForm.phoneNumber,
        logInType: this.logInType
      };
      const res = await this.$http.getMessage(params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log(res);
      this.codeSuccess = res;
    },

    async sendCode() {
      console.log(this.randstr);
      this.codeMessage().then(() => {
        if (this.codeSuccess) {
          const timeCount = 60;

          if (!this.timer) {
            this.count = timeCount;
            this.codeShow = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= timeCount) {
                this.count--;
              } else {
                this.codeShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          ElMessage.warning({
            message: '请稍后再试',
            type: 'warning'
          });
        }
      }).catch(error => {
        console.log(error);
      });
      console.log('123');
    },

    async getBaseSet() {
      const res = getStorage('projectBaseData') || {};
      this.showZhs = res.zhs_login;
      this.showSso = res.sso_login;
      this.logoUrl = res.login_url;
      this.loginBg = res.home_page_background_url || '';
    },

    // 项目状态
    async getObjectStatus() {
      const res = await this.$http.getObjectStatus();
      console.log('状态', res);

      if (!res.status) {
        window.location.href = '/stop.html';
      }
    },

    /* 切换tab */
    async handlerTabs() {
      this.$refs.loginForm.resetFields();
    }

  }
};